/**
 * File Upload Editor
 * Handles configuration for file-upload controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for file-upload control
 */
function renderFileUploadEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Accept (file types)
          <input
            type="text"
            value={(control.config?.accept as string) || ''}
            onChange={(e) => onConfigChange('accept', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="e.g. .pdf,.jpg,image/*"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Max File Size (bytes)
          <input
            type="number"
            min="0"
            value={(control.config?.maxSize as number) ?? ''}
            onChange={(e) => onConfigChange('maxSize', e.target.value ? parseInt(e.target.value) : undefined)}
            className="af-properties-tab__input"
            placeholder="No limit"
          />
        </label>
      </div>
      <div className="af-properties-tab__checkbox-group">
        <label className="af-properties-tab__checkbox-label">
          <input
            type="checkbox"
            checked={(control.config?.multiple as boolean) || false}
            onChange={(e) => onConfigChange('multiple', e.target.checked)}
          />
          Allow Multiple Files
        </label>
      </div>
    </div>
  );
}

/**
 * FileUploadEditor - Handles file-upload control configuration
 */
export const FileUploadEditor: PropertyEditor = {
  type: 'file-upload',
  label: 'File Upload',
  description: 'Configure file type restrictions and upload settings',
  render: renderFileUploadEditor,
};
